import {Input, Form, Modal, Radio} from "antd";
import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {RadioContainer, RadioList} from "./CourierReportProblemModalStyled.js";
import {courierReportReasons} from "../../../../constants/constants.js";
import {useFormik} from "formik";
import * as yup from "yup";
import {CRPMPropTypes} from "./CRPMPropTypes";

import {useStore} from "../../../../hooks/useStore";
const CourierReportProblemModal = ({visibility, onCancel, shift}) => {
    const [confirmLoading, setConfirmLoading] = useState();
    const {t} = useTranslation(["selectReasons", "textBoxFormModal", "shiftScore"]);
    const [reasonText, setReasonText] = useState("");
    const [moreInfo, setMoreInfo] = useState(false);
    const stores = useStore();

    useEffect(() => {
        if (!visibility) {
            resetForm();
            setMoreInfo(false);
            setReasonText("");
        }
    }, [visibility]);

    const validationRules = () => {
        if (!reasonText) {
            return yup.object().shape({
                reason: yup
                    .string()
                    .required(t("validation.selectionRequired", {ns: "textBoxFormModal"}))
                    .min(5, t("validation.min5Letter", {ns: "textBoxFormModal"}))
            });
        } else if (reasonText.length <= 5) {
            return yup.object().shape({
                reason: yup
                    .string()
                    .required(t("validation.reasonRequired", {ns: "textBoxFormModal"}))
                    .min(5, t("validation.min5Letter", {ns: "textBoxFormModal"}))
            });
        }
    };
    const formik = useFormik({
        initialValues: {text: "", detailText: "", reason: ""},
        validationSchema: validationRules(),
        onSubmit: async (values: CRPMPropTypes) => {
            const report = {
                shiftId: shift._id,
                issue:
                    values.reason === "0"
                        ? t("shiftScore.courierReportProblemModal.other", {
                              ns: "shiftScore"
                          })
                        : values.reason,
                detailText: reasonText
            };
            await stores.shiftStore.reportShiftProblem(report);
            await resetForm();
            onCancel();
        },
        enableReinitialize: false
    });

    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        resetForm,
        handleBlur
    } = formik;

    const courierReportTypeRender = () => {
        return courierReportReasons.map((reason, i) => {
            return (
                <React.Fragment key={i}>
                    <RadioList key={reason.value} data-testid={`reason`} value={reason.value}>
                        {reason.label}
                        {/* TODO: i18n{t(reason.translation_key, {ns: "selectReasons"})} */}
                    </RadioList>
                </React.Fragment>
            );
        });
    };

    const renderMoreInfo = () => {
        if (moreInfo) {
            return (
                <Input.TextArea
                    style={{marginTop: "20px"}}
                    name="reason"
                    value={reasonText}
                    onChange={e => setReasonText(e.target.value)}
                    data-testid={`CourierReportProblemModal_detailTextArea`}
                />
            );
        } else {
            return <React.Fragment />;
        }
    };

    const handleEventChange = event => {
        if (event.target.value === "0") {
            setMoreInfo(true);
        } else {
            setReasonText("");
            setMoreInfo(false);
        }
    };

    const renderRadioGroup = () => (
        <RadioContainer>
            <Radio.Group
                name="reason"
                value={values.reason}
                onChange={e => {
                    handleChange(e);
                    handleEventChange(e);
                }}
                data-testid={`CourierReportProblemModal_reasons`}
            >
                {courierReportTypeRender()}
            </Radio.Group>
        </RadioContainer>
    );

    const renderFormItem = () => {
        return (
            <>
                <Form.Item
                    colon={false}
                    label={t("shiftScore.courierReportProblemModal.resasonLabel", {
                        ns: "shiftScore"
                    })}
                    labelAlign="left"
                    validateStatus={errors.reason && touched.reason ? "error" : "success"}
                    help={errors.reason && touched.reason ? errors.reason : null}
                >
                    {renderRadioGroup()}
                    {renderMoreInfo()}
                </Form.Item>
            </>
        );
    };

    return (
        <Modal
            centered
            title={t("shiftScore.courierReportProblemModal.title", {ns: "shiftScore"})}
            visible={visibility}
            confirmLoading={confirmLoading}
            okText={t("shiftScore.courierReportProblemModal.reasonSubmit", {ns: "shiftScore"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
            onOk={handleSubmit}
            data-testid={`CourierReportProblemModal`}
            onCancel={() => {
                onCancel();
                resetForm();
            }}
        >
            <Form autoComplete="off" labelCol={{span: 24}} wrapperCol={{span: 24}}>
                {renderFormItem()}
            </Form>
        </Modal>
    );
};

export default CourierReportProblemModal;
